/**
 * Email Notification Service (100% Static & Serverless Client-Side Dispatcher)
 * Designed for static builds (dist/) hosted on Cloudflare Pages, Firebase Hosting, Vercel, Netlify, cPanel, etc.
 * Dispatches email notifications directly from browser JS to:
 * - juridico@asesoriasem.com (Primary)
 * - hola@caoslab.dev (CC)
 * - gerajes90@gmail.com (CC)
 */

/**
 * Dispatches an automated email notification when a new lead or property consignment arrives.
 * @param {Object} leadData
 */
export const notifyAdminsOfNewLead = async (leadData = {}) => {
  try {
    const isVisit = leadData.category === 'interes' || leadData.serviceType === 'visita' || Boolean(leadData.propertyId);
    const clientName = leadData.clientName || leadData.name || 'Prospecto / Cliente';
    const clientPhone = leadData.phone || 'No registrado';
    const clientEmail = leadData.email || 'No proporcionado';
    const propertyTitle = leadData.propertyTitle || 'Inmueble General';
    const preferredDate = leadData.preferredDate || '';
    const message = leadData.message || 'Sin detalles adicionales';

    const clientPhoneClean = clientPhone.replace(/\D/g, '');
    const waLink = clientPhoneClean
      ? `https://wa.me/52${clientPhoneClean}?text=${encodeURIComponent(`Hola ${clientName}, le saluda el Lic. Edgar Molina de EM Asesoría respecto a su solicitud en asesoriasem.com.`)}`
      : 'N/A';

    const subject = isVisit
      ? `📅 Nueva Solicitud de Visita: ${clientName} - ${propertyTitle}`
      : `🏡 Nueva Propiedad en Consignación: ${propertyTitle} - ${clientName}`;

    // Payload for FormSubmit AJAX API (Works 100% in static web without backend server)
    const emailPayload = {
      _subject: subject,
      _cc: 'hola@caoslab.dev,gerajes90@gmail.com',
      _template: 'table',
      _captcha: 'false',
      'Tipo de Solicitud': isVisit ? 'Agenda de Visita / Interés en Inmueble' : 'Propietario / Consignación para Venta o Renta',
      'Nombre del Prospecto': clientName,
      'Teléfono / WhatsApp': clientPhone,
      'Correo Electrónico': clientEmail,
      'Inmueble / Propiedad': propertyTitle,
      'Fecha Deseada para Recorrido': preferredDate || 'Por coordinar con el cliente',
      'Mensaje / Detalles': message,
      'Enlace Directo a WhatsApp': waLink,
      'Fecha y Hora': new Date().toLocaleString('es-MX', { timeZone: 'America/Chihuahua' })
    };

    // Send direct HTTP request from browser
    const response = await fetch('https://formsubmit.co/ajax/juridico@asesoriasem.com', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(emailPayload)
    });

    if (response.ok) {
      const result = await response.json();
      console.log('[Email Notifier] Notificación enviada exitosamente a los administradores:', result);
      return result;
    }
  } catch (error) {
    // Non-blocking catch to guarantee the user's UI experience is never interrupted
    console.warn('[Email Notifier Warning] No se pudo enviar el correo de notificación:', error.message);
  }
};
